(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cv-product__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var targetId = thumb.getAttribute('data-target');
        var img = document.getElementById(targetId);
        if (!img) return;
        img.src = thumb.getAttribute('data-image');
        img.alt = thumb.getAttribute('data-alt') || '';
        var thumbs = thumb.parentElement.querySelectorAll('.cv-product__thumb');
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    document.querySelectorAll('.cv-product__qty').forEach(function(wrap) {
      var input = wrap.querySelector('.cv-product__qty-input');
      wrap.querySelectorAll('.cv-product__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var current = parseInt(input.value, 10) || 1;
          if (btn.dataset.action === 'increase') input.value = current + 1;
          if (btn.dataset.action === 'decrease' && current > 1) input.value = current - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.querySelectorAll('.cv-product__variant-select').forEach(function(select) {
      select.addEventListener('change', function() {
        var form = select.closest('form');
        if (!form) return;
        var selects = form.querySelectorAll('.cv-product__variant-select');
       var values = Array.prototype.map.call(selects, function(s) { return s.value; });
        var dataEl = form.querySelector('[data-cv-variants]');
        var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
        var match = variants.find(function(v) {
          return v.options.every(function(o, i) { return o === values[i]; });
        });
        if (match) window.location.href = window.location.pathname + '?variant=' + match.id;
      });
    });

    document.querySelectorAll('form.cv-product__form').forEach(function(form) {
      if (form.dataset.cvDrawer) return;
      form.dataset.cvDrawer = 'true';

      form.addEventListener('submit', function(e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        e.preventDefault();

        var btn = form.querySelector('[name="add"]');
        if (btn) {
          if (btn.disabled) return;
          btn.disabled = true;
          btn.classList.add('is-loading');
        }

        var errorEl = form.querySelector('.cv-product__error');
        if (errorEl) errorEl.hidden = true;

        var formData = new FormData(form);
        formData.append('sections', drawer.getSectionsToRender().map(function(s) { return s.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            if (res.status) {
              if (errorEl) {
                errorEl.textContent = res.description || res.message || 'Er ging iets mis, probeer het opnieuw.';
                errorEl.hidden = false;
              }
              return;
            }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: res });
            }
          })
          .catch(function() { form.submit(); })
          .finally(function() {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
